var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "application-page" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [_c("Navigation", { attrs: { page: "security" } })],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "8" } }, [
                _c("h1", [_vm._v("Daten & Sicherheit")]),
                _vm._v(" "),
                _c("div", { staticClass: "main-content" }, [
                  _c("div", { staticClass: "tag-sections" }, [
                    _vm.application
                      ? _c(
                          "section",
                          [
                            _c("h2", [_vm._v("Persönliche Daten")]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c("b-col", { attrs: { md: "2" } }, [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-extra-bold" },
                                    [_vm._v("Name:")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { md: "10" } }, [
                                  _vm._v(_vm._s(_vm.application.name))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mt-2" },
                              [
                                _c("b-col", { attrs: { md: "2" } }, [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-extra-bold" },
                                    [_vm._v("E-Mail:")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { md: "10" } }, [
                                  _vm._v(_vm._s(_vm.application.email))
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mt-2" },
                              [
                                _c("b-col", { attrs: { md: "2" } }, [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-extra-bold" },
                                    [_vm._v("Mobilnummer:")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { md: "10" } }, [
                                  _vm._v(
                                    _vm._s(_vm.application.phone.formatted)
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.application.domicile
                              ? _c(
                                  "b-row",
                                  { staticClass: "mt-2" },
                                  [
                                    _c("b-col", { attrs: { md: "2" } }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-extra-bold"
                                        },
                                        [_vm._v("Wohnort:")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { md: "10" } }, [
                                      _vm._v(_vm._s(_vm.application.domicile))
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "section",
                      [
                        _c("h2", [_vm._v("Sicherheit")]),
                        _vm._v(" "),
                        _vm.application
                          ? _c("Info", {
                              attrs: {
                                meta: _vm.meta,
                                "get-security": _vm.getSecurity,
                                "change-identification":
                                  _vm.changeIdentification,
                                "resend-resend-function":
                                  _vm.resendResendFunction,
                                "resend-change-function":
                                  _vm.resendChangeFunction,
                                email: _vm.application.email,
                                phone: _vm.application.phone,
                                "with-my-data": false,
                                "with-security-title": false
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }